import { EntitlementStatementType } from '@dreryk/egabinet-patient-frontend-api';

import { FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, RadioGroup, RadioGroupItem } from '@dreryk/react-components';

import { entitlementStatementsTranslationKeys } from '../../translations';

export const STATEMENT_TYPE_RADIO_ITEMS: RadioGroupItem<EntitlementStatementType>[] = [
   {
      id: 'FOR_BENEFICIARY',
      label: entitlementStatementsTranslationKeys.createModal.beneficiary,
   },
   {
      id: 'FOR_REPRESENTATIVE',
      label: entitlementStatementsTranslationKeys.createModal.representative,
   },
];
type StatementTypeProps = FieldControllerProps<'entitlementStatementType', string | null> & ClassNameProp;

export const StatementTypeField = (props: StatementTypeProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: true,
   });

   return (
      <RadioGroup<EntitlementStatementType>
         testId={props.name}
         items={STATEMENT_TYPE_RADIO_ITEMS}
         controller={controller}
         horizontal
         label={entitlementStatementsTranslationKeys.createModal.statementType}
      />
   );
};
